<template>
  <div class="container-fluid m-0 p-0">
    <Card>
      <template slot="header">
        <h4>{{ ReportDetail.nameFamily }}</h4>
        <hr />
      </template>
      <template slot="content">
        <tab :tab="Tablist">
          <template v-slot:content0>
            <div class="row" style="hight: 30vh !important">
              <div class="col-md-4 col-12 text-center">
                <span style="font-size: xx-small !important; font-wight: bold" class="d-block">تعداد تیکت</span>
                <span class="text-lg glow-yellow mt-2 d-block">
                  {{ ReportDetail.countTicket }}
                </span>
              </div>
              <div class="col-md-4 col-12 text-center">
                <small class="d-block">تعداد پیام</small>
                <span class="text-lg glow-blue">
                  {{ ReportDetail.messageCount }}
                </span>
              </div>
              <div class="col-md-4 col-12 text-center">
                <small class="d-block">امتیاز </small>
                <span class="text-lg glow-red">
                  {{ ReportDetail.messageScore }}
                </span>
              </div>
              <div class="col-12">
                <hr />
              </div>
              <div v-if="ReportDetail.countTicket > 0" class="col-md-6 col-12 text-center">
                <small class="d-block">وضعیت تیکت ها </small>
                <PieChart :theme="1" :fixedSeries="grp41Series" :ChartData="ReportDetail.pichart41Data" :Height="100"></PieChart>
              </div>
              <div v-if="ReportDetail.countTicket > 0" class="col-md-6 col-12 text-center">
                <small class="d-block">نوع تیکت ها </small>
                <PieChart :theme="3" :ChartData="ReportDetail.pichart45Data"></PieChart>
              </div>
              <div v-else class="col-12">
                <h3 class="text-center">در این بازه تیکتی ثبت نشده است</h3>
              </div>
            </div>
          </template>
          <template v-slot:content1> <TicketCpGrid :Rows="ReportDetail.tickets"></TicketCpGrid> </template>
          <template v-slot:content2>
            <div class="row">
              <div class="col-12">
                <h3>پراکندگی تیکت ها در روز</h3>
                <DataInDayChart :config="{ colors: ['#f084af'], ytitle: 'تیکت در روز' }" :data="DayticketData"></DataInDayChart>
              </div>
              <div class="col-12">
                <h3>پراکندگی پاسخها در روز</h3>
                <DataInDayChart :config="{ colors: ['#00ad85'], ytitle: 'پیام در روز' }" :data="DayMessageData"></DataInDayChart>
              </div>
            </div>
          </template>
        </tab>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue'
import PieChart from './PieChart.vue'
import TicketCpGrid from './TicketCpGrid.vue'
import DataInDayChart from './DataInDayChart.vue'
import Tab from '@/components/Tab/Tab.vue'

export default {
  components: { Card, PieChart, Tab, TicketCpGrid, DataInDayChart },
  props: ['ReportDetail', 'dates'],
  data() {
    return {
      Tablist: [{ header: 'وضعیت کلی' }, { header: 'لیست تیکت ها' }, { header: ' اطلاعات روزانه' }],
      grp41Series: ['تحويل نسخه', 'تست', 'بسته شده', 'در حال انجام', 'در حال رسيدگي', 'پاسخ مشتري', 'پاسخ داده شده', 'باز', 'بايگاني', 'نگه داشته شده'],
      DayMessageData: [],
      DayticketData: [],
    }
  },
  methods: {
    BuildDataForDaygrid(Array) {
      console.warn(Array)
      var data = []
      var startDate
      var EndDate
      if (this.dates[0].length > 0) {
        startDate = this.dates[0]
      } else {
        startDate = this.$store.state.JalaliDate.substring(0, 4) + ' /1/1'
      }
      if (this.dates[1].length > 0) {
        EndDate = this.dates[1]
      } else {
        EndDate = this.$store.state.JalaliDate
      }
      var dates = this.$getDaysArray(startDate, EndDate)
      dates.forEach((date) => {
        var x = Array.filter((x) => x.dateTimeInsert.indexOf(date) >= 0)
        var temp = { date: date, Count: x.length, name: this.ReportDetail.nameFamily }
        data.push(temp)
      })

      return data
    },
  },
  created() {
    this.DayticketData = [this.BuildDataForDaygrid(this.ReportDetail.tickets)]
    this.DayMessageData = [this.BuildDataForDaygrid(this.ReportDetail.messages)]
  },
}
</script>
<style scoped>
.text-lg {
  font-size: x-large;
}
.glow-yellow {
  color: #ffd700 !important;
  text-shadow: 0px 0px 7px rgba(255, 215, 0, 0.62);
}
.glow-blue {
  color: #5cb0ff !important;
  text-shadow: 0px 0px 7px #5cb0ff9f;
}
.glow-red {
  color: #d84315 !important;
  text-shadow: 0px 0px 7px #d84215c4;
}
</style>
